import { render, staticRenderFns } from "./PostCarousel.vue?vue&type=template&id=b412cd28&scoped=true&"
import script from "./PostCarousel.vue?vue&type=script&lang=js&"
export * from "./PostCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b412cd28",
  null
  
)

export default component.exports